export interface Segment {
  text: string;
  hit: boolean;
}

/** Splits text into plain/matched segments for every occurrence of query (case-insensitive). */
export function splitHighlight(text: string, query: string): Segment[] {
  if (!query) return [{ text, hit: false }];
  const lower = text.toLowerCase();
  const q = query.toLowerCase();
  const segments: Segment[] = [];
  let i = 0;
  while (i < text.length) {
    const idx = lower.indexOf(q, i);
    if (idx === -1) {
      segments.push({ text: text.slice(i), hit: false });
      break;
    }
    if (idx > i) segments.push({ text: text.slice(i, idx), hit: false });
    segments.push({ text: text.slice(idx, idx + q.length), hit: true });
    i = idx + q.length;
  }
  return segments;
}
